import { Box } from '@chakra-ui/react';
import React from 'react';
import ReactPlayer from 'react-player';
import { TransitionalVideoProps } from '../interfaces/components';

function TransitionVideo({ videoURL, room, playing, setPlaying }: TransitionalVideoProps) {
  return (
    <Box
      className="transition-ui"
      position="fixed"
      width="100%"
      zIndex="999999"
      h="100%"
      top="0"
      opacity={playing ? 1 : 0}
      visibility={playing ? 'visible' : 'hidden'}
      transition={playing ? 'none' : 'visibility 0s linear 1s, opacity 1s'}
    >
      <Box className="transition-player" id="transition-player">
        <ReactPlayer
          progressInterval={1}
          onProgress={(prog) => {
            const percentagePlayed = Math.floor(prog.played * 100);
            if (percentagePlayed === 20) {
              // Goto whatever room you want to transition into
              window.GotoScene(room);
            }
          }}
          id="transition-video"
          height="100%"
          width="100%"
          style={{ minHeight: '100vh' }}
          loop={false}
          muted
          controls={false}
          playing={playing}
          url={videoURL}
          onEnded={() => setPlaying()}
          playsinline
        />
      </Box>
    </Box>
  );
}

export default TransitionVideo;
